module.exports = __webpack_public_path__ + "img/jcsj9-content.8cb45409.png";